import { render, staticRenderFns } from "./systemLinkedCompanies.vue?vue&type=template&id=5382c1a8&scoped=true"
import script from "./systemLinkedCompanies.vue?vue&type=script&lang=js"
export * from "./systemLinkedCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382c1a8",
  null
  
)

export default component.exports